<!-- 使用方法参考 appcenter/consume/pos/center.vue 顶部操作栏 -->
<template>
  <!--suppress JSUnresolvedVariable -->
  <button class="-button" @click="emitClick($event)" style="border-radius: 4px;"
  ><i class="el-icon-plus margin-right-4"></i>{{value}}</button>
</template>

<script>
export default {
  name: 'button-add',
  props: {
    value: {
      type: String,
      default: '添加'
    }
  }
}
</script>

<style scoped lang="less">
  @import "../styles/fun_var";

  .-button {
    height: 32px;
      padding: 5px 15px !important;
        font-size: 13px !important;
        line-height: 32px;
    .generate-common-button(#1362FF)

  }
</style>



// WEBPACK FOOTER //
// src/components/common/buttons/button-add.vue